module.exports = __webpack_public_path__ + "img/xxky.9f455578.png";